<template>
<div class="chapter">
<div class="inner_page">
      ﻿

	
		<title>Collection of Sand: Essays</title>
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<h2 class="brandingPartNum" id="col0000090">I</h2>
<div class="hrframe" id="col0000091">
<div class="hr" id="col0000092"> </div>
</div>
<h3 class="EB04SmallCapsMainHead2" id="page_3">EXHIBITIONS—EXPLORATIONS</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?3a5bb147